/** OAuth timeout. */
export const OAuthTimeout = 15e3;
